<template>
  <div class="about mh-100">
    <div class="h-100" v-if="!fetchingData">
      <ProfileSetup v-if="showProfile && !fetchingData"/>
      <Waiver v-if="showWaiver && !fetchingData"/>
      <Survey v-if="showSurvey && !fetchingData" />
      <Result class="mh-100" v-if="showResult && !fetchingData" />
    </div>
  </div>
</template>

<script>
const { isBefore, isAfter } = require('date-fns')
const firebase = require("firebase");
import Waiver from '../components/Waiver'
import Result from '../components/Result'
import ProfileSetup from '../components/ProfileSetup'
import Survey from '../components/Survey'

export default {
  name: 'MainDisplay',
  components: {
    Waiver,
    Result,
    ProfileSetup,
    Survey
  },
  methods: {
    calcSemester (dt) {
      const candidate = new Date(dt)
      const endSpring = new Date(candidate.getFullYear(), 5, 15)
      const beginFall = new Date(candidate.getFullYear(), 7, 1)
      if (isBefore(candidate, endSpring)) {
        return `${candidate.getFullYear}01`
      }
      if (isAfter(candidate, beginFall)) {
        return `${candidate.getFullYear()}03`
      }
      return `${candidate.getFullYear()}02`
    }
  },
  computed: {
    fetchingData () {
      return this.$store.getters.fetchingData
    },
    needsProfile () {
      return !this.$store.getters.hasProfile
    },
    needsWaiver () {
      const lastWaiver = this.$store.getters.lastWaiver
      if (this.$store.getters.traits.length > 0) {
        if (this.$store.getters.traits.indexOf('staff') !== -1) {
          return false
        }
      }
      if (!lastWaiver) return true
      
      return this.currentSemester !== this.lastWaiverSemester
    },
    needsSurvey () {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
      if (!this.$store.getters.lastSurvey) return true

      const lastSurvey = this.$store.getters.lastSurvey.completed
      if (!lastSurvey) {
        return true
      }

      return isBefore(this.$store.getters.lastSurvey.completed, today)
    },
    currentSemester () {
      const now = Date()
      return this.calcSemester(now)
    },
    showProfile () {
      return this.needsProfile
    },
    showWaiver () {
      return !this.showProfile && this.needsWaiver
    },
    showSurvey () {
      return !this.showProfile && !this.showWaiver && this.needsSurvey
    },
    showResult () {
      return !this.showProfile && !this.showSurvey && !this.showWaiver
    },
    lastWaiverSemester () {
      if (!this.$store.getters.lastWaiver) {
        return null
      }
      return this.calcSemester(this.$store.getters.lastWaiver.completed)
    },
    lastSurvey () {
      return this.$store.getters.lastSurvey.completed
    }
  },
  mounted () {
    // this.$store.dispatch('fetchUserProfile')
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: 'AIzaSyCbB-7CihyBpgzM7p_vmKeA2QQOcmBEH2M',
        authDomain: 'bldg-screen.firebaseapp.com',
        projectId: 'bldg-screen'
      });
    }

    const u = firebase.auth().currentUser
    if (!u) {
      this.$router.push('/')
    }

    // console.log('USER', u)
  }
}
</script>